(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1677],{

/***/ 4173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1283);
/* harmony import */ var _components_pages_proyectos_RealestateList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30005);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);








var Propiedad = function Propiedad(props) {
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_4__.useTranslations)("title-pages");
  var filters = {
    refRequest: "propiedades-list-query",
    detailPath: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_2__/* .CPagesPath.es.property_detail */ .K.es.property_detail,
    filters: {
      typeProperty: []
    }
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("title", null, titleT("properties")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: ""
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: "Propiedad exclusivos, proyecto exclusivo en construcci\xF3n, proyecto exclusivo construido, Propiedad exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almac\xE9n en venta, casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almac\xE9n en alquiler, Propiedad exclusivos de remax rep\xFAblica dominicana"
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(props.url)),
    key: "canonical"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_pages_proyectos_RealestateList__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    defaultFilters: filters
  }));
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Propiedad);

/***/ }),

/***/ 22135:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/propiedades",
      function () {
        return __webpack_require__(4173);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,2708,1629,8407,2615,6877,4022,70,3843,1664,7918,9043,8543,2960,7956,3828,4864,841,2834,311,9343,4816,6939,8360,7872,6626,4831,6809,3282,2210,8654,9470,1207,5,2888,179], function() { return __webpack_exec__(22135); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);